interface HeaderProps {
	children: React.ReactNode;
	className?: string;
}

export function H1({ children, className = "" }: HeaderProps) {
	return (
		<h1
			className={`text-3xl font-extrabold md:text-4xl lg:text-5xl ${className}`}
		>
			{children}
		</h1>
	);
}

export function H2({ children, className = "" }: HeaderProps) {
	return (
		<h2
			className={`text-2xl font-bold md:text-3xl lg:text-4xl ${className}`}
		>
			{children}
		</h2>
	);
}

export function H3({ children, className = "" }: HeaderProps) {
	return (
		<h3
			className={`text-xl font-bold md:text-2xl lg:text-3xl ${className}`}
		>
			{children}
		</h3>
	);
}

export function Lead({ children, className = "" }: HeaderProps) {
	return (
		<p className={`text-md opacity-50 sm:text-lg lg:text-xl ${className}`}>
			{children}
		</p>
	);
}
export function Paragraph({ children, className = "" }: HeaderProps) {
	return (
		<p className={`text-lg md:text-xl lg:text-2xl ${className}`}>
			{children}
		</p>
	);
}

export function Highlight({ children }: HeaderProps) {
	return (
		<span className="rounded-lg bg-green-800 px-1 font-bold">
			{children}
		</span>
	);
}
